<template lang="pug">
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          em Hola 
            span.text-capitalize {{user.name}}
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
            small {{moment().locale('es').format('MMMM')}} 
            | {{ Math.ceil(moment().date() / 7) }}
            small a 
            | Semana
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              .col-4.form-group.align-items-center.mb-4
                label.col-3.pl-0.m-0 Lider
              
              .col-4.form-group.align-items-center.mb-4
                //- label.col-3.pl-0.m-0 Lider
                .col.px-0.ad_select
                  select(v-model='selectedLider')
                      option(:value="null" disabled) Selecciona lider
                      option(:value="leader.value" v-for="leader in leaders") {{leader.label}}
              .col-4.form-group.align-items-center.mb-4
                button.col-auto.stepper-button.next.ml-auto(@click="addSession()")
                  span Crear
                  i.material-icons

                                
            .d-flex.flex-row.mt-5
              
      .d-flex.row.flex-row.align-items-start
        .col-12
          .card.p-0.ad_border1-secondary.mb-5.rounded-xl(v-for="(session, index) in sessions")
            .card-body
              .row.mb-3
                .col
                  .h2.mb-3.ad_text-primary
                    i {{session.user_evaluated.name}}
                .col-auto.align-self-center
                  button.btn.py-2.px-3.font-weight-bold(@click="showLiderChange(index)" :class="controlShowLiders[index] ? 'btn-graySecondary' : 'btn-warning text-white'")
                    span(v-if="!controlShowLiders[index]")
                      | Mostrar detalle
                      i.fas.fa-chevron-down.ml-2
                    span(v-if="controlShowLiders[index]")
                      | Ocultar detalle
                      i.fas.fa-chevron-up.ml-2
              b-collapse.row(id="index" v-model="controlShowLiders[index]")
                .col-12.py-2(v-if="session.kpicon.length > 0")
                  table.table-order-less_style.w-100
                    thead
                      tr
                        th
                          .h4.font-weight-bold
                            | KPI Adherencia
                        th(width="10%")
                        th(width="10%")
                          | Foco
                        th(width="10%")
                    tbody                  
                      tr(v-for="(k, indexk) in session.kpicon")
                        td
                          .row.m-0
                            .col.d-flex.flex-wrap.py-2.rounded-xxl.ad_bg-gray.mr-4
                              .col-auto.pl-0
                                a(id="kpiad2")
                                  i.icon-letters.icon-letters__viaje.mr-1 V
                                  i.icon-letters.icon-letters__producto.mr-1 P
                                  i.icon-letters.icon-letters__segmento.mr-1 S
                                  i.icon-letters.icon-letters__negocio.mr-1 N
                                b-tooltip(target="kpiad2" , placement='top')
                                  | {{k.travel ? k.travel.name: ''}} + {{k.product ? k.product.name: ''}} + {{k.segemnt ? k.segemnt.name: ''}} + {{k.kpi ? k.kpi.name: ''}}
                                span
                                  i.icon-letters.icon-letters__kpi.mr-1 A
                              .col.pl-0
                                | {{k.kpi ? k.kpi.name : ''}}
                            .col-auto.py-2.rounded-xxl.ad_bg-gray
                              | {{k.percentage_business}}%
                        td
                          .input-refresh.d-flex.flex-row.align-items-center.ml
                            input(type="text" v-model="percentageBusiness" max='100' maxlength='3')
                            | %
                            a#kpinegocio(href="#")
                              i.fas.fa-info-circle.ad_text-secondary.ml-1
                            b-tooltip(target="kpinegocio" , placement='top')
                              | % de Cumplimiento del KPI de Negocio obtenido la semana pasada
                        td.text-center
                          i.icon-checkmark.ad_text-success.icon--1-5x(v-if="indexk == 0")
                        td(v-if="indexk == 0 && session.state.order == 0", rowspan="2")
                          a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openKpi(index)" :class="[gestionadoK ? 'btn-info' : 'btn-secondary']")
                            | {{ refreshKpi }}
                .col-12.py-2(v-else)
                  table.table-order-less_style.w-100
                    thead
                      tr
                        th
                          .h4.font-weight-bold
                            | KPI Adherencia
                        th(width="10%")
                        th(width="10%")
                        th(width="10%")
                    tbody
                      tr
                        td
                          .row.m-0
                            .col.d-flex.flex-wrap.py-2.rounded-xxl.ad_bg-gray.text-center
                              //.- .col-auto.pl-0
                                a(id="kpiad2")
                                  i.icon-letters.icon-letters__viaje.mr-1 -
                                  i.icon-letters.icon-letters__producto.mr-1 -
                                  i.icon-letters.icon-letters__segmento.mr-1 -
                                  i.icon-letters.icon-letters__negocio.mr-1 -
                                b-tooltip(target="kpiad2" , placement='top')
                                  | Viaje + Producto + Segmento + Negocio
                                span
                                  i.icon-letters.icon-letters__kpi.mr-1 -
                              .col.pl-0
                                | No hay kpi asignados
                            //.- .col-auto.py-2.rounded-xxl.ad_bg-gray
                              | --%
                          td.text-center
                            strong --
                              small ta
                          td.text-center
                            i.icon-blocked.icon--1-5x
                          td(rowspan="2", v-if="session.state.order == 0")
                            a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openKpi(index)" :class="[gestionadoK ? 'btn-info' : 'btn-secondary']")
                              | {{ refreshKpi }}
                
                hr.w-95.mx-auto.border-top.border-gray

                .col-12.py-2(v-if="session.personal_development.length > 0")
                  table.table-order-less_style.w-100
                    thead
                      tr
                        th
                          .h4.font-weight-bold
                            | Desarrollo personal
                        th
                        th(width="10%")
                        th(width="10%")
                        th(width="10%")  
                    tbody                  
                      tr(v-for="(pd, indexpd) in session.personal_development")
                        td
                          .col-12.py-2.rounded-xxl.ad_bg-gray
                            span.num_circle.ad_bg-secondary.mr-2
                              | {{indexpd + 1}}
                            | {{pd.category.name}}
                        td
                          .col-12.py-2.rounded-xxl.ad_bg-gray
                            | {{pd.subcategory.name}}
                        td
                          .form-group.ad_select
                          select(v-model='selectedCritic')
                            option(value="null" selected) Criticidad
                            option(:value="critic" v-for="crtitic in criticidades") {{crtitic.name}}
                        td.text-center
                          i.icon-checkmark.ad_text-success.icon--1-5x(v-if="indexpd == 0")
                        td(v-if="indexpd == 0 && session.state.order == 0", rowspan="2")
                          a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openPD(index)" :class="[gestionadoD ? 'btn-info' : 'btn-secondary']")
                            | {{ refreshDesarrollo }}
                .col-12.py-2(v-else)
                  table.table-order-less_style.w-100
                    thead
                      tr
                        th
                          .h4.font-weight-bold
                            | Desarrollo personal
                        th(width="10%")
                        th(width="10%")
                        th(width="10%")
                    tbody
                      tr
                        td
                          .col-12.py-2.rounded-xxl.ad_bg-gray.text-center
                            | No hay desarrollos personales asignados
                        td.text-center
                          //- strong --
                          //-   small ta
                        td.text-center
                          i.icon-blocked.icon--1-5x
                        td(rowspan="2", v-if="session.state.order == 0")
                          a.btn.font-weight-bold.text-white.py-2.px-4(title="Actualizar" @click.stop="openPD(index)" :class="[gestionadoD ? 'btn-info' : 'btn-secondary']")
                            | {{ refreshDesarrollo }} 
                .col-12.py-2.rounded-xl.ad_bg-gray.mb-3(v-if="sessions.length == 0")
                  .col-12.text-center.rounded-lg.ad_bg-gray.pt-3
                    p.muted No hay Líderes asignados

                hr.w-95.mx-auto.border-top.border-gray

                .col-12.py-2
                  .col-8
                    .h4.font-weight-bold
                      em Minuta
                  .col-12.form-group.align-items-center.mb-4
                    textarea.form-control(maxlength='100' rows="3" placeholder='ingresa descripción' title='Descripción')
                    .col-auto.form-group.align-items-center.mb-0.pr-0
                .col-12.py-2
                  .form-group.justify-content-between.mt-3
                    button.col-auto.stepper-button.next.ml-auto(@click="updateSession()")
                      span Guardar
                    button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="showUpdateConfirm('updateK','los Kpi')")
                      span.font-weight-bold Cerrar
                      i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom

    v-navigation-drawer(v-model='drawerObjetivos', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4(v-if="currentPL")
          i {{currentPL.user_evaluated.name}}
      section.py-4.px-2.overflowy-auto
        .col-12
          .row
            .col-12.d-flex.align-items-center.justify-content-between.py-2
              h3.ad_text-primary.my-2
                i Actividades de Desarrollo Personal
              
          .card.rounded-lg.ad_border1-secondary.p-0.mb-4
            .card-body(v-if="currentPL")
              .row.mb-1
                .col.font-italic.mr-3.d-flex.justify-content-between
                  span Competencia
                .col.font-italic.mr-3.d-flex.justify-content-between
                  span Actividad
                  span
                .col-3.font-italic.text-center
                  span Cumple
                .col-1
              .row.desafios-semanales(v-if="currentPL.personal_development.length > 0")
                .col-12.ad_text-dangerDark(v-if="errorPD")
                  p.ad_bg-dangerLight.px-3.py-2.rounded
                    i.fas.fa-times-circle.mr-1
                    | Debe seleccionar si se cumplió o no este Objtivo de Desarrollo
                .col-12.d-flex.flex-row(v-for="(pd, ind) in currentPL.personal_development")
                  .col.pl-0.py-3.border-bottom
                    .row.ad_bg-gray.rounded-xl.py-3.m-0
                      .w-75.px-3
                        | {{pd.category.name}}
                  .col.pl-0.py-3.border-bottom
                    .row.ad_bg-gray.rounded-xl.py-3.m-0                      
                      .w-75.px-3
                        | {{pd.subcategory.name}}
                      .w-25.px-3.text-right
                        strong {{pd.date | WeekDuration}}ta 
                        i sem
                  .col-auto.d-flex.px-0.py-3.border-bottom.align-items-center.justify-content-around
                    //- c-form-radio.mr-2.ad_radio.ad_radio-cumple(:name="'pd' + ind" v-model="accomplishedPD[ind]" value="true" label="Si")
                    //- c-form-radio.ml-2.ad_radio.ad_radio-nocumple(:name="'pd' + ind" v-model="accomplishedPD[ind]" value="false" label="No")
                  .col-auto.pr-0.py-3.d-flex.align-items-center.border-bottom
                    button.btn.btn__small.btn-secondary-border.font-weight-bold(@click.stop="showCloseConfirm('closePD', 'el Desarrollo', pd, currentPL._id, ind)")
                      | Cerrar
              .row.d-flex.justify-content-center.my-3
                .col-auto(v-if="currentPL")
                  b-button.btn.btn__medium.btn-success.py-2.w-100(@click="objetivodp = !objetivodp")
                    i.fas.fa-plus-circle.mr-1
                    span.m-0.font-weight-bold Añadir Objetivo de Desarrollo Personal
              b-collapse(v-model="objetivodp" id="objetivoDP")
                .card.py-0.border-0.rounded-xl.ad_bg-gray
                  .card-body
                    .row
                      .col-12
                        .h5.font-weight-bold.font-italic
                          | Crear Nueva Competencia
                        .form-group.ad_select
                          select(v-model='selectedCategoria', @change='getSubByCat($event)')
                            option(value="null" selected) Selecciona competencia
                            option(:value="category" v-for="category in categories") {{category.name}}
                        .form-group.ad_select
                          select(v-model='selectedSubcategoria')
                            option(value="null" selected) Selecciona actividad
                            option(:value="objetivo" v-for="objetivo in subcategories") {{objetivo.name}}
                        .row.mt-4.mb-2
                          .col.d-flex.justify-content-between
                            button.btn.btn-graySecondary-border.btn__medium
                              i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                              span.ad_text-grayMedio Cancelar
                            button.btn.btn-success-border.btn__medium
                              span.font-weight-bold.pl-2(@click="createPDCon()") Crear
                              i.fas.fa-plus-circle.ml-1
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerObjetivos = !drawerObjetivos")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="showUpdateConfirm('updatePD', 'los desarrollos personales')")
              span.font-weight-bold Grabar
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          c-scroll-view(style="height:300px;")
            div(v-if="currentPlanComments")  
              div(v-for="c in currentPlanComments")
                .row.mb-3
                  .col-4.pr-0
                    p.font-weight-bold.m-0 {{c.user.name}}
                    small.d-block {{c.date | DateFormat}}
                    small.d-block {{c.date | HourFormat}} hrs.
                    small.d-block {{c.type}}
                  .col-8.pl-0
                    .dialog-box
                      p {{c.comment}}
              .row.mb-3
                b-pagination(
                  v-model="currentPageDp"
                  :total-rows="totalRowsDp"
                  :per-page="perPage",
                  @input="selectedPage('Desarrollo Personal')",
                  class="my-0")

    v-navigation-drawer(v-model='drawerComentarios', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4(v-if="currentPL")
          i {{ currentPL.user_evaluated.name }}
      section.py-4.px-2.overflowy-auto
        .col-12
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(v-model="commentToSend", placeholder="Ingrese comentarios", rows="4")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerComentarios = !drawerComentarios;canContinue(css)")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToLiderPlan('general')")
              span.font-weight-bold Añadir comentario
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          div(v-if="currentPlanComments")  
            div(v-for="c in currentPlanComments")
              .row.mb-3
                .col-4.pr-0
                  p.font-weight-bold.m-0 {{c.user.name}}
                  small.d-block {{c.date | DateFormat}}
                  small.d-block {{c.date | HourFormat}} hrs.
                  small.d-block {{c.type}}
                .col-8.pl-0
                  .dialog-box
                    p {{c.comment}}
            .row.mb-3
              b-pagination(
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage",
                @input="selectedPage('null')",
                class="my-0")
  
    v-navigation-drawer(v-model='drawerKpi', app='', temporary='', right='', width='800')
        header.ad_bg-primary.pt-2.pb-2.px-4
          h2.h2.text-white.mt-4(v-if="currentPL")
            i {{currentPL.user_evaluated.name}}
        section.py-4.px-2.overflowy-auto
          .col-12          
            .row
              .col-12.d-flex.align-items-center.justify-content-between.py-2
                h3.ad_text-primary.my-2
                  i KPIs Adherencia

            .card.rounded-lg.ad_border1-secondary.p-0.mb-4
              .card-body(v-if="currentPL")
                .kpi-adherencia.mb-2.border-bottom(v-for="(k, indek) in currentPL.kpicon")
                  .row
                    .col.font-italic
                      h3.font-weight-bold KPIs
                    .col.text-right
                      h3 {{k.date | WeekDuration}}ta 
                        small semana
                  .row.justify-content-end.mb-1
                    .col-12
                      .row.ad_bg-gray.rounded-lg.py-3.m-0
                        .col-12.mb-3
                          i.icon-letters.icon-letters__viaje.mr-1  V
                          span {{k.travel ? k.travel.name: ''}}
                        .col-12.mb-3
                          i.icon-letters.icon-letters__producto.mr-1 P 
                          span {{k.product ? k.product.name: ''}}
                        .col-12.mb-3
                          i.icon-letters.icon-letters__segmento.mr-1 S
                          span {{k.segment ? k.segment.name: ''}}
                        .col-12.d-flex.flex-nowrap.mb-3
                          .w-75
                            i.icon-letters.icon-letters__negocio.mr-1 N
                            span {{k.business_type ? k.business_type.name: ''}}
                          .w-25.text-right
                            | {{k.percentage_business}}%
                            a#kpinegocio
                              i.fas.fa-info-circle.ad_text-secondary.ml-1
                            b-tooltip(target="kpinegocio" , placement='top')
                              | % de Cumplimiento del KPI de Negocio
                        .col-12.d-flex.flex-nowrap.mb-3
                          .w-75
                            i.icon-letters.icon-letters__kpi.mr-1 A
                            span {{k.kpi ? k.kpi.name: ''}}
                          .w-25.text-right
                            | {{k.percentage_adherence}}%
                            a#kpiadherencia
                              i.fas.fa-info-circle.ad_text-secondary.ml-1
                            b-tooltip(target="kpiadherencia" , placement='top')
                              | % de Cumplimiento del KPI de Adherencia
                        
                  .row.d-flex.justify-content-center.my-3(v-if="k._id")
                    .col-12.ad_text-dangerDark(v-if="errorK")
                      p.ad_bg-dangerLight.px-3.py-2.rounded
                        i.fas.fa-times-circle.mr-1
                        | Debe seleccionar si se cumplió o no este KPI
                    .col.d-flex.align-items-center.justify-content-end
                      label.font-weight-bold.h5.m-0.pr-2 Cumple:
                      c-form-radio.ad_radio.ad_radio-cumple.pr-3(:name="'kpi' + indek" v-model="accomplishedK[indek]" value="true" label="Si")
                      c-form-radio.ad_radio.ad_radio-nocumple(:name="'kpi' + indek" v-model="accomplishedK[indek]" value="false" label="No")
                    .col-4
                      button.btn.btn__medium.btn-secondary-border.py-2.w-100(@click.stop="closeKpiConsultor(k, currentPL._id, indek)")
                        span.m-0.font-weight-bold Cerrar
                
                .row.d-flex.justify-content-center.my-3
                  .col-auto(v-if="currentPL")
                    b-button.btn.btn__medium.btn-success.py-2.w-100(@click="newKPI = !newKPI")
                      i.fas.fa-plus-circle.mr-1
                      span.m-0.font-weight-bold Añadir KPI Adherencia
                b-collapse(v-model="newKPI" id="addkpi")
                  h3.ad_text-grayMedio.mb-2
                    i Nuevo KPI Adherencia
                  .card.py-0.border-0.rounded-xl.ad_bg-gray
                    .card-body
                      .form-group.row.align-items-center
                        .col-auto.pl-0.pr-2
                          i.icon-letters.icon-letters__viaje.mr-1 V
                        .col.px-0.ad_select
                          select(v-model='selectedViaje', @change='getSegments($event)')
                            option(:value="null" disabled) Selecciona viaje
                            option(:value="travel", v-for="travel in travels", :key="travel._id") {{travel.name}}
                      .form-group.row.align-items-center
                        .col-auto.pl-0.pr-2
                          i.icon-letters.icon-letters__segmento.mr-1 S
                        .col.px-0.ad_select(:class='{disabled : !selectedViaje }')
                          select(v-model="selectedSegmento", :disabled='!selectedViaje', @change='getProducts($event)')
                            option(:value="null" disabled) Selecciona segmento
                            option(:value="segment" v-for="segment in segments" :key="segment._id") {{segment.name}}
                      .form-group.row.align-items-center
                        .col-auto.pl-0.pr-2
                          i.icon-letters.icon-letters__producto.mr-1 P
                        .col.px-0.ad_select(:class='{disabled : !selectedSegmento }')
                          select(v-model="selectedProducto", :disabled='!selectedSegmento', @change='getBusinessTypes($event) + getKpisByIds($event)')
                            option(:value="null" disabled) Selecciona Producto
                            option(:value="product" v-for="product in products" :key="product._id") {{product.name}}
                      .form-group.d-flex.row.align-items-center.justify-content-between
                        .col-auto.px-0
                          i.icon-letters.icon-letters__negocio.mr-1 N
                        .col.d-flex.col-9.p-0
                          .ad_select(:class='{disabled : !selectedProducto }')
                            select(v-model='selectedKpiNegocio', :disabled='!selectedProducto', @change='setPorcentage($event)')
                              option(:value="null" disabled) Selecciona KPI Negocio
                              option(:value="business" v-for="business in businesstypes" :key="business._id") {{business.name}}
                        .d-flex.col-auto.pr-0.d-flex.align-items-stretch
                          .d-flex.ad_text-grayMedio.text-center.w-100
                            .input-refresh.d-flex.flex-row.align-items-center.ml(:class='{disabled : !selectedProducto }')
                              input(type="text" v-model="percentageBusiness" :disabled='!selectedProducto' max='100' maxlength='3')
                              | %
                              a#kpinegocio(href="#")
                                i.fas.fa-info-circle.ad_text-secondary.ml-1
                              b-tooltip(target="kpinegocio" , placement='top')
                                | % de Cumplimiento del KPI de Negocio obtenido la semana pasada
                      .form-group.d-flex.row.align-items-center.justify-content-between
                        .col-auto.px-0
                          i.icon-letters.icon-letters__kpi.mr-1 A
                        .col.d-flex.col-9.p-0
                          .ad_select(:class='{disabled : !selectedKpiNegocio }')
                            select(v-model='selectedKpiAdherencia' :disabled='!selectedKpiNegocio')
                              option(:value="null" disabled) Selecciona KPI Adherencia
                              option(:value="kpi" v-for="kpi in kpis" :key="kpi._id") {{kpi.name}}
                        .d-flex.col-auto.pr-0.d-flex.align-items-stretch
                          .d-flex.ad_text-grayMedio.text-center.w-100
                            .input-refresh.d-flex.flex-row.align-items-center.ml-2(:class='{disabled : !selectedKpiNegocio }')
                              input(type="text" v-model="percentageAdherence" :disabled='!selectedKpiNegocio' max='100' maxlength='3')
                              | %
                              a#kpiadherencia(href="#")
                                i.fas.fa-info-circle.ad_text-secondary.ml-1
                              b-tooltip(target="kpiadherencia" , placement='top')
                                | % de Cumplimiento del KPI de Adherencia obtenido la semana pasada
                      .form-group.d-flex.row.align-items-center.justify-content-between.mt-4.mb-2
                        .col.d-flex.px-0.justify-content-between
                          button.btn.btn-graySecondary-border.btn__medium(@click="newKPI = !newKPI")
                            i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                            span.ad_text-grayMedio Cancelar
                          button.btn.btn-success-border.btn__medium
                            span.font-weight-bold.pl-2(@click.stop="createKpiCon()") Crear
                            i.fas.fa-plus-circle.ml-1
            .row
              .col-12
                h3.ad_text-primary.my-2
                  i Comentarios
                .form-group.align-items-center
                  textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
            .form-group.justify-content-between.mt-3
              button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerKpi = !drawerKpi")
                i.far.fa-times-circle.fa-1x.mr-2.align-bottom
                | Cancelar
              button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="showUpdateConfirm('updateK','los Kpi')")
                span.font-weight-bold Grabar
                i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
            
            hr.my-4
            
            h3.ad_text-grayMedio.mb-2
              i Historial de comentarios
            div(v-if="currentPlanComments")  
              div(v-for="c in currentPlanComments")
                .row.mb-3
                  .col-4.pr-0
                    p.font-weight-bold.m-0 {{c.user.name}}
                    small.d-block {{c.date | DateFormat}}
                    small.d-block {{c.date | HourFormat}} hrs.
                    small.d-block {{c.type}}
                  .col-8.pl-0
                    .dialog-box
                      p {{c.comment}}
              .row.mb-3
                b-pagination(
                  v-model="currentPageK"
                  :total-rows="totalRowsK"
                  :per-page="perPage",
                  @input="selectedPage('Kpi')",
                  class="my-0")
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'ConsultorHomeExt',

  data () {
    return {
      user: {},
      leaders: [],
      selectedLider: null,
      totalPlans: 0,
      totalPD: 0,
      session: null,
      sessions: [],
      loaded: false,
      controlShowLiders: [],
      refreshDesarrollo: 'Actualizar',
      refreshKpi: 'Actualizar',
      refreshDesafio: 'Actualizar',
      gestionadoD: false,
      gestionadoK: false,
      gestionadoDS: false,
      drawerComentarios: null,
      drawerDesafio: null,
      drawerKpi: null,
      drawerObjetivos: null,
      currentWC: {},
      currentPL: null,
      currentPLindex: null,
      currentKpi: {},
      currentPD: {},
      currentPlanComments: [],
      commentToSend: null,
      totalRows: 0,
      totalPages: 0,
      perPage: 5,
      currentPage: 1,
      totalRowsDp: 0,
      totalRowsDs: 0,
      totalRowsK: 0,
      totalPagesDp: 0,
      totalPagesDs: 0,
      totalPagesK: 0,
      currentPageDs: 1,     
      currentPageDp: 1,
      currentPageK: 1,
      percentageAdherence: 0,
      selectedKpiNegocio: null,
      selectedKpiAdherencia: null,
      selectedCritic: null,
      newKPI: false,
      kpis: [],
      percentageAdherence: 0,
      percentageBusiness: 0,
      selectedProducto: null,
      selectedViaje: null,
      selectedCategoria: null,
      selectedSubcategoria: null,
      selectedSegmento: null,
      products: [],
      segments: [],
      states: [],
      subcategories: [],          
      travels: [],
      businesstypes: [],
      categories: [],
      objetivodp: false,
      errorPD: false,
      errorK: false,
      criticidades: [
        {name: 'critico'},
        {name: 'insuficiente'},
        {name: 'en desarrollo'},
        {name: 'adecuado'},
        {name: 'optimo'}
      ]
    }
  },
  methods: {
    moment,
    ...mapActions('consultant', [
      'actualWeekEvaluations', 'persDeveByPlanConOpen'
    ]),
    ...mapActions('user', [
      'getLeaders',
      'myTeam'
    ]),
    ...mapActions('plan_con', [
      'planByWeekCon', 'createPlanCo'
    ]),
    ...mapActions('weeklychallenge', [
      'getWcByUser'
    ]),
    ...mapActions('session', [
      'createSession', 'mySessions', 'updatePersonalDevelopment'
    ]),
    ...mapActions('category', [
      'categoriesList', 'getCatById'
    ]),
    ...mapActions('subcategory', [
      'byCategoryId', 'getSubcatById'
    ]),
    ...mapActions('travel', [
      'travelList', 'getTravelById', 'getTravelsByRoles'
    ]),
    ...mapActions('segment', [
      'ByTravelId', 'getSegmentById', 'getSegmentByRoles'
    ]),
    ...mapActions('product', [
      'BySegmentId', 'getProductById', 'getProductByRoles'
    ]),
    ...mapActions('businesstype', [
      'businessTypeByIds', 'businessBySegTraProd'
    ]),
    ...mapActions('role', [
      'byTriplets'
    ]),
    ...mapActions('kpi', [
      'kpiByIds', 'getKpiById'
    ]),
    getItemsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: p.name, profile: p.profilename, leader: p.leader}))
    },
    getPerDevelopments() {
      const vm = this;
      vm.persDeveByPlanConOpen({plan: vm.session._id}).then(response => {
        vm.personalDevelopments = vm.$store.getters['consultant/getPersonalDevelopments']
        vm.checkTotalPdDone()
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    checkTotalPdDone() {
      const vm = this
      for (let p of vm.personalDevelopments) {
        if (p.state.order == 2) {
          vm.totalPD++
        }
      }
    },
    checkTotalPlDone() {
      const vm = this
      for (let p of vm.collabsInformation) {
        if (p.plan) {
          if (p.plan.state.order == 2) {
            vm.totalPlans++
          }
        }
      }
    },
    addSession() {
      const vm = this
      let currentWeek = moment().isoWeek()
      vm.createSession({
        user: vm.user.id,
        user_evaluated: vm.selectedLider
      }).then((response) => {
        vm.sessions.push(response);
        vm.$notify(false, 'Sesion creada');
      }, (error) => {
        // vm.$notify(true, error.payload.message);
        vm.$notify({
          type: 'info',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      });
    },
    updateSession() {
      const vm = this
      vm.createSession({
        user: vm.user.id,
        user_evaluated: vm.selectedLider
      }).then(() => {         
        vm.$notify(false, 'Sesion actualizada');
      }, (error) => { 
        vm.$notify({
          type: 'info',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      });
    },
    classPlDone(index) {
      const vm = this
      return {
        'ad_text-success': vm.collabsInformation[index].plans.done == vm.collabsInformation[index].plans.total, 
        'ad_text-grayMedio': vm.collabsInformation[index].plans.done != vm.collabsInformation[index].plans.total
      }          
    },
    loadLeaders(id) {
      const vm = this
      vm.myTeam(id).then(response => {
        vm.leaders = vm.getItemsToMultiSelectLoad(response)
      });
    },
    loadSessions(id) {
      const vm = this
      vm.mySessions({id: id}).then(response => {
        vm.sessions = response;
        vm.addControlLider();
      });
    },
    showLiderChange: function(index) {
      const vm = this
      let sp = vm.controlShowLiders[index] ? false : true
      vm.controlShowLiders.splice(index, 1, sp);
    },
    canContinueDesarrollo () {
      if (this.gestionadoDS && this.gestionadoK) {
        this.$emit('can-continue', {value: true})
      }
      this.refreshDesarrollo = this.refreshDesarrollo.replace("Actualizar", "Gestionado")
      this.gestionadoD = true
      return this.gestionadoD
    },
    canContinueKpi (css) {
      if (this.gestionadoDS && this.gestionadoD) {
        this.$emit('can-continue', {value: true})
      }
      this.refreshKpi = this.refreshKpi.replace("Actualizar", "Gestionado")
      this.gestionadoK = true
      return this.gestionadoK
    },
    canContinueDesafio () {
      if (this.gestionadoD && this.gestionadoK) {
        this.$emit('can-continue', {value: true})
      }
      this.refreshDesafio = this.refreshDesafio.replace("Actualizar", "Gestionado")
      this.gestionadoDS = true
      return this.gestionadoDS
    },
    addControlLider() {
      const vm = this
      for (let index in vm.sessions) {
        vm.controlShowLiders.push(false)
      }
    },
    openDesafio: function (planindex) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.sessions[planindex]
      vm.currentPLindex = planindex
      vm.getComments('Desafio Semanal').then(() => {
        loading.hide()
        vm.drawerDesafio = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })      
    },
    openKpi: function (planindex) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.sessions[planindex]
      vm.currentPLindex = planindex
      vm.travelsByRole().then(() => {
        vm.getComments('Kpi').then(() => {
          loading.hide()
          vm.drawerKpi = true
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (e) => {
        console.info(e)
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    openPD: function (planindex) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.sessions[planindex]
      vm.currentPLindex = planindex   
      vm.getComments('Desarrollo Personal').then(() => {
        loading.hide()
        vm.drawerObjetivos = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      }) 
    },
    openComments: function(index) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.currentPL = vm.sessions[index]      
      vm.getComments(null).then(() => {
        loading.hide()
        vm.drawerComentarios = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })                
    },
    createPDCon: function () {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      // if (vm.currentPL.personal_development.length < 2) {
        if (vm.selectedCategoria && vm.selectedSubcategoria) {
          vm.currentPL.personal_development.push({
            description: vm.pddescription,
            session: vm.currentPL._id,
            date: moment(),
            category: vm.selectedCategoria,
            subcategory: vm.selectedSubcategoria
          })
          vm.pddescription = null
          vm.objetivodp = false     
          loading.hide()
        } else {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe completar el formulario',
            closeable: true,
            duration: 5000
          })
        }
      // } else {
      //   vm.drawerObjetivos = false
      //   loading.hide()
      //   vm.$notify({
      //     type: 'danger',
      //     title: 'Notificación',
      //     content: 'No puede agregar mas de dos desarollo personal',
      //     closeable: true,
      //     duration: 5000
      //   })
      // }
    },
    getCategories() {
      const vm = this
      vm.categoriesList().then(() => {
        vm.categories = vm.$store.getters['category/getCategories']
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    getSubByCat() {
      const vm = this
      if (vm.selectedCategoria) {
        vm.byCategoryId(vm.selectedCategoria._id).then(() => {
          vm.subcategories = vm.$store.getters['subcategory/getSubcategories']
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }
    },
    getComments(type) {
      return new Promise ((resolve, reject) => {
        const vm = this
        // if (vm.notEmptyObject('currentPL')) {

        //   let varPag = ''
        //   if (type == 'Desafio Semanal') {
        //     varPag = 'Ds'
        //   } else if (type == 'Desarrollo Personal') {
        //     varPag = 'Dp'
        //   } else if (type == 'Kpi') {
        //     varPag = 'K'
        //   }

        //   vm.getCommentsByPlanLider({id: vm.currentPL._id, type: type, pagination: {page: vm[`currentPage${varPag}`], perPage: vm.perPage}}).then(() => {
        //     let res = vm.$store.getters['comments_plancon/getComments']
        //     vm.currentPlanComments = res.docs            
        //     vm[`totalRows${varPag}`] = res.total
        //     vm[`totalPages${varPag}`] =  res.totalPages
          resolve()
        //   }, (error) => {
        //     reject(error)
        //   })
        // } else {
        //   resolve()
        // }
      })      
    },
    getTravels() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.travelList({ids: vm.currentPL.user_evaluated.travel}).then(() => {
          vm.travels = vm.$store.getters['travel/getTravels']
          resolve()
        }, (error) => {
          reject()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      })      
    },
    travelsByRole() {
      return new Promise((resolve, reject) => {
        const vm = this
        vm.getTravelsByRoles({roles: vm.currentPL.user_evaluated.role}).then(() => {
          vm.travels = vm.$store.getters['travel/getTravels']
          resolve();
        }, (error) => {
          reject(error);
        });
      });
    },
    getSegments($event) {
      const vm = this
      const loading = vm.$toast.loading('Cargando segmentos...')
      vm.selectedProducto = null
      vm.selectedKpiNegocio = null
      vm.selectedKpiAdherencia = null
      vm.registroNegocio = 0
      vm.registroAdherencia = 0
      vm.getSegmentByRoles({roles: vm.currentPL.user_evaluated.role, travel: vm.selectedViaje._id}).then(() => {
        vm.segments = vm.$store.getters['segment/getSegments']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getProducts($event) {
      const vm = this
      vm.selectedKpiNegocio = null
      vm.registroNegocio = 0
      vm.registroAdherencia = 0
      vm.selectedKpiAdherencia = null
      const loading = vm.$toast.loading('Cargando productos...')
      vm.getProductByRoles({roles: vm.currentPL.user_evaluated.role, segment: vm.selectedSegmento._id}).then(() => {
        vm.products = vm.$store.getters['product/getProducts']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getBusinessTypes($event) {
      const vm = this
      vm.selectedKpiAdherencia = null
      vm.registroAdherencia = 0
      const loading = vm.$toast.loading('Cargando kpis de negocio...')
      vm.businessBySegTraProd({
        segment: vm.selectedSegmento._id, 
        travel: vm.selectedViaje._id,
        product: vm.selectedProducto._id 
      }).then(() => {
        vm.businesstypes = vm.$store.getters['businesstype/getBusinessType']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getKpisByIds($event) {
      const vm = this
      const loading = vm.$toast.loading('Cargando kpis de adherencia...')
      vm.byTriplets({
        travel: vm.selectedViaje._id, 
        segment: vm.selectedSegmento._id, 
        product: vm.selectedProducto._id
      }).then((roles) => {
        //filtrar por role de usuarios.
        let rolesFiltered = []
        let rolesForFilter = vm.currentPL.user_evaluated.role
        if (roles.length > 0) { 
          for (let r of roles) {
            for (let ur of rolesForFilter) {
              if (r._id.toString() == ur) {
                rolesFiltered.push(r)
              }
            }
          }
        }
        vm.kpiByIds({ role: rolesFiltered}).then(() => {
          vm.kpis = vm.$store.getters['kpi/getKpis']
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    showUpdateConfirm(type, message) {
      const vm = this
      this.$dialog
      .confirm(`Desea grabar ${message}`, {okText: 'Continuar', cancelText: 'Cancelar'})
      .then(function(dialog) {
        switch(type) {
          case 'updatePD':
            vm.updatePD('Desarrollo Personal')
            break;
          case 'upadteWC':
            vm.upadteWC('Desafio Semanal')
            break;
          case 'updateK':
            vm.updateK('Kpi')
            break;
        }
      })
      .catch(function() {
        console.log('Clicked on cancel');
      });
    },
     updatePD(type) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando...')
      
      // vm.addCommentToLiderPlan(type).then(() => {
        vm.updatePersonalDevelopment({
          data: vm.currentPL.personal_development,
          session: vm.currentPL._id
        }).then((plupdated) => {
          vm.errorPD = false
          vm.commentToSend = null
          vm.collabsPlans[vm.currentPLindex].personal_development = plupdated
          loading.hide()
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Desarrollo personal agregado',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      // }, (error) => {
      //   loading.hide()
      //   vm.$notify({
      //     type: 'danger',
      //     title: 'Notificación',
      //     content: error.payload.message,
      //     closeable: true,
      //     duration: 5000
      //   })
      // })
    },
    createKpiCon: function () {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      // if (vm.currentPL.kpicon.length < 2) {
        if (vm.selectedKpiAdherencia && vm.percentageBusiness && vm.percentageAdherence) {
          vm.currentPL.kpicon.push({
            plan_lider: vm.currentPL._id,
            plan_con: vm.currentPL._id,
            date: moment(),
            percentage_business: vm.percentageBusiness,
            percentage_adherence: vm.percentageAdherence,
            kpi: vm.selectedKpiAdherencia,
            business_type: vm.selectedKpiNegocio,
            segment: vm.selectedSegmento,
            travel: vm.selectedViaje,
            product: vm.selectedProducto,
            accomplished: false
          })
          vm.percentageBusiness = 0
          vm.percentageAdherence = 0
          vm.selectedKpiAdherencia = null
          vm.selectedSegmento = null
          vm.selectedViaje = null
          vm.selectedProducto = null
          vm.newKPI = false     
          loading.hide()
        } else {          
          loading.hide()
            vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe completar todos los datos en el formulario.',
            closeable: true,
            duration: 5000
          })
        }
      // } else {
      //   vm.drawerKpi = false
      //   loading.hide()
      //   vm.$notify({
      //     type: 'danger',
      //     title: 'Notificación',
      //     content: 'No puede agregar mas de dos kpis',
      //     closeable: true,
      //     duration: 5000
      //   })
      // }
    }
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user;
    const loading = vm.$toast.loading('Cargando...');
    vm.user = vm.$store.getters['auth/getUserInfo'];

    if (vm.user.profile.name == 'Consultor externo') {
      vm.getCategories();
      vm.loadLeaders(id);
      vm.loadSessions(id);
      loading.hide();
    } else {
      console.log("HOME NO");
      loading.hide();     
      vm.$router.replace({ path: '/permission' })
    }
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/consultor-externo/consultor-externo-home.vue